import { gql } from '@apollo/client';

export const GET_TOOL_BY_ID = gql`
  query GetToolById($id: ID!, $availabilityStartDate: ISO8601Date!) {
    tool(id: $id) {
      id
      name
      description
      disabled
      primaryImageUrl
      pricePerDayCents
      isOwnTool
      address
      city
      postalCode
      latitude
      longitude
      locationArea(radiusM: 200) {
        latitude
        longitude
        radiusM
      }
      brandName
      model
      powerDescription
      condition
      weightGrams
      ageMonths
      usageInstructions
      includedItems
      maxAvailableCount
      reviewCount
      ratingAverage
      nextAvailableDate(date: $availabilityStartDate)
      toolAvailabilityPeriods(startDate: $availabilityStartDate) {
        id
        startDate
        endDate
        available
      }
      relevantToolBookings(startDate: $availabilityStartDate) {
        id
        fromDate
        toDate
        status
      }
      images {
        id
        url
        position
        primary
      }
      categories {
        id
        name
        code
      }
      owner {
        id
        name
        createdAt
        about
        reviewCount
        ratingAverage
        avatarImageUrl
      }
      reviews {
        id
        rating
        comment
        createdAt
        createdByUser {
          id
          name
          avatarImageUrl
        }
      }
    }
  }
`;
